<template>
    <div class="container _container">
        <div class="containerbody">
            <div class="content">
                <div class="content_left">
                    <el-card>
                        <div class="sideBar">
                            <div class="head_title">WHAT WE DO</div>
                            <div >
                                <div class="sub_title">CRIME&nbsp;INVETIGATION</div>
                                <div class="sub_title">ASSISANCE</div>
                            </div>
                            <div class="divide_line"></div>
                            <div class="nav">JOINT&nbsp;ACTION</div>
                            <div class="nav">JOINT&nbsp;PATROL</div>
                            <div class="nav">CAPACITY&nbsp;BUILDING</div>
                            <div class="nav">SCHOLARSHIP</div>
                            <div class="nav">ACADEMY</div>
                            <div class="nav">INTEGRATED COORDINATION<br> & OPERATIONAL SUPPORT</div>

                        </div>
                    </el-card>
                </div>
                <div class="content_right">
                    <el-card>
                        <div slot="header" class="text_title">
                            <span>CRIME INVETIGATION ASSISANCE</span>
                        </div>

                        <div class="text_content">
                            Secretary-General&nbsp;You&nbsp;Xiaowen&nbsp;Leads&nbsp;Delegation&nbsp;on&nbsp;Visit&nbsp;to&nbsp;Myanmar
                        </div>
                        <el-divider></el-divider>
                      <div class="text_content">
                        SG Zheng Baigang Paid Visit to "Safe Mekong" Operation Coordination Center
                      </div>
                      <el-divider></el-divider>
                      <div class="text_content">
                        The 4th Lancang-Mekong Integrated Law Enforcement and Security Cooperation Forum
                      </div>
                      <el-divider></el-divider>
                        <!-- <div class="share_box">
                            <div class="share_img" @click="shareClick">
                                <img :src="imageUrl" width="40" height="40" />
                            </div>
                            <div class="share_img">
                                <img :src="imageUrl2" width="40" height="40" />
                            </div>
                        </div> -->
                    </el-card>
                </div>
            </div>
        </div>
        <shareDialog ref="shareDialog"></shareDialog>
    </div>
  </template>

  <script>
    import shareDialog from './subcomponents/shareDialog'
  export default {

    name: 'aboutUs',
    components: {
        shareDialog
    },
    data(){
        return{
            imageUrl:require('@/components/aboutUs/imgs/facebook.png'),
            imageUrl2:require('@/components/aboutUs/imgs/Twitter.png'),

        }
    },
    methods:{
        shareClick(){
            this.$refs.shareDialog.open('Repost to Facebook',{})

        },
    }
  }
  </script>

  <style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px){
      .container{
        width: 100%;
        overflow: hidden;
        .containerbody{
            width: 100%;
            // max-width:1000px ;
            background-color: rgb(249, 249, 249);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;
            .content{
                width: 80%;
                margin: 0 auto;
                .content_left{
                    width: 16%;
                    float: left;
                    .sideBar{
                        text-align: left;
                        width: 100%;
                        .head_title{
                            padding: 0 0 20px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Bold;
                            font-weight: 700;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        .sub_title{
                            padding: 4px 0;
                            color: rgba(51, 51, 51, 1);
                            font-family: SourceHanSansCN-Regular;
                            font-size: 12px;

                        }
                        .divide_line{
                            width: 90%;
                            height: 1.5px;
                            margin:4px 0;
                            background-color: #2D52D0;
                        }
                        .nav{
                            overflow-wrap: break-word;
                            color: rgba(110, 110, 115, 1);
                            font-size: 12px;
                            font-family: SourceHanSansCN-Regular;
                            font-weight: normal;
                            white-space: nowrap;
                            line-height: 24px;
                            margin: 15px 0 10px 0;
                        }
                    }
                }
                .content_right{
                    width:82%;
                    float: right;
                    // margin-left: 3%;
                    .text_title{
                        width: 100%;
                        // padding: 32px 0;
                        text-align: left;
                        font-family: SourceHanSansCN-Bold;
                        font-weight: 700;
                        color: rgba(51, 51, 51, 1);
                        font-size: 16px;
                        // font-weight: bold;
                    }
                    .text_content{
                        width: 98%;
                        padding: 0 1%;
                        line-height: 22px;
                        text-align: left;
                        font-size: 13px;
                        font-family: SourceHanSansCN-Regular;
                        color: rgba(110, 110, 115, 1);
                    }
                    .share_box{
                        height: 100px;
                        float: right;
                        margin-top: 50px;
                        .share_img{
                            float: left;
                            margin: 4px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
      }
  }

  // 小于800px
  @media only screen and (max-width: 800px){
      .container{
      }
  }
  </style>



// WEBPACK FOOTER //
// src/components/whatWeDo/index.vue